import React, {useEffect, useState, useRef} from 'react';
import '../App.css';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import Bodyheaderloged from './bodyheaderloged'
import Grillasausuarios from './grillasausuarios'
import Axios from 'axios';
import { useNavigate } from "react-router-dom";


function Bodyhomeadmintickets (){    
    const navigate = useNavigate();

    let statuscall = '' 
    
    useEffect(() => {  

    }, [])


    return (
        <div className='sshbodyappContainerLogin'>
            <div className='sshbodyappContainerRegister'>
                <Bodyheaderloged/>
            </div>
            <div className='sshbodyappContainerLoginForm'>
                <div className='container'>     
                    <Grillasausuarios/>
                </div>
            </div>
        </div>            
    )
}
export default Bodyhomeadmintickets